import { getAbexList } from 'models/application/constants';

export const getBuildingConditionOfAverageSchema = () => {
  return {
    condition_of_average: {
      type:       'section',
      title:      t('wizard.building.condition_of_average.title'),
      properties: {
        sum_insured:             {
          validations: ['required', 'maxLength10', 'only_int_price'],
          label:       t('wizard.building.assessment.sum_insured'),
          component:   'price',
        },
        abex:                    {
          validations: ['required'],
          label:       t('wizard.building.assessment.abex'),
          component:   'select',
          list:        getAbexList(),
        },
      },
      visible:    {
        property:  'building.evaluation.evaluation_type',
        assertion: 'equal',
        value:     'Condition_of_average',
      },
    },
  };
};
